










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EquipmentsSolesBattery extends Vue {
  @Prop({ required: true }) private value!: number;
  @Prop(Boolean) private checked!: boolean;

  batteryColor(value: number) {
    const _v = this.checked ? value : -1;
    switch (true) {
      case _v <= 25:
        return 'error';
      case _v >= 25 && _v <= 50:
        return 'warning';
      case _v >= 50:
        return 'success';
      default:
        return 'grey';
    }
  }

  /**
   * Convert a value (0 - 100) to an icon of battery
   * @param value
   */
  batteryIcon(value: number | string) {
    const _v = this.checked ? parseInt(value as string) : -1;
    switch (true) {
      case _v >= 10 && _v <= 25:
        return '$vuetify.battery-quarter--d';
      case _v >= 25 && _v <= 50:
        return '$vuetify.battery-half--d';
      case _v >= 50 && _v <= 75:
        return '$vuetify.battery-three-quarters--d';
      case _v >= 75 && _v <= 100:
        return '$vuetify.battery-full--d';
      default:
        return '$vuetify.battery-empty--d';
    }
  }
}
